import React, { useState } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { withRouter, useParams } from 'react-router-dom';
import queryString from 'query-string';

import DatePresenter from '../../presenters/DatePresenter';
import CashbackRates from '../../pages/CashbackRates';
import { StoreProvider } from '../../components';

const cashbackRatesContainerQuery = graphql`
  query CashbackRatesContainerQuery(
    $storeIdEq: ID!
    $afterDate: Date!
    $beforeDate: Date!
  ) {
    brand: store(id: $storeIdEq) {
      ...CashbackRatesContainer_brand
    }
  }
`;

const Container = createFragmentContainer(CashbackRates, {
  brand: graphql`
    fragment CashbackRatesContainer_brand on Store {
      id
      name
      defaultCashbackRates(afterDate: $afterDate, beforeDate: $beforeDate) {
        startDate
        endDate
        rate
        state
      }
      birthdayCashbackRates(afterDate: $afterDate, beforeDate: $beforeDate) {
        startDate
        endDate
        rate
        state
      }
    }
  `,
});

const CashbackRatesContainer = (props) => {
  const {
    location: { search },
  } = props;
  const { brandId } = useParams();
  const queryParams = queryString.parse(search);
  const afterDate = queryParams.afterDate || DatePresenter.oneMonthAgo();
  const beforeDate = queryParams.beforeDate || DatePresenter.oneMonthAhead();
  const initialParams = () => {
    const variables = {
      storeIdEq: brandId,
      afterDate,
      beforeDate,
    };

    return variables;
  };

  const [searchParams, setSearchParams] = useState(initialParams);

  const preprocessParams = () => {
    return searchParams;
  };

  return (
    <StoreProvider
      {...props}
      container={Container}
      modern
      preprocessParams={preprocessParams}
      onSearchParamsChange={setSearchParams}
      searchParams={searchParams}
      query={cashbackRatesContainerQuery}
    />
  );
};

export default withRouter(CashbackRatesContainer);
